var exports = {
  "e": "x936d19a0--9b9b39--suggest-error",
};

module.exports = exports;
